import Vue from "vue";
import VueRouter from "vue-router";
import store from "./../store";
import routes from "./../router/routes";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (token) store.dispatch("setToken", token);

  if (!to.meta.middleware) return next();
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store,
  };

  const runMiddleware = (middleware, index, context) => {
    const actualMiddleware = middleware[index];
    actualMiddleware(context)
      .then(() => {
        const nextMiddleware = middleware[index + 1];
        if (!nextMiddleware) return context.next();
        runMiddleware(middleware, index + 1, context);
      })
      .catch((err) =>
        console.warn("Você não tem permissão para acessar este endereço", err)
      );
  };

  runMiddleware(middleware, 0, context);
});

router.afterEach((to) => {
  document.title = to.meta.title
    ? `${to.meta.title} | Cartaz Pratico`
    : "Cartaz Pratico";
});

export default router;
